<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">
			<el-form-item label="房源编号" prop="room_num"><br>
				<el-select style="width: 100%;" v-model="inputmodel.room_num" placeholder="请选择房间"
					v-el-select-loadmore="loadmore" @change="changeselect">
					<el-option v-for=" item in options" :key="item.id" :label="item.flat+`—`+item.room_num"
						:value="item.room_num">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"
					@change="formatAmount(`${item.model}`)"></el-input>
			</el-form-item>
			<el-form-item label="房源编号" prop="room_num"><br>
				<el-select style="width: 100%;" v-model="inputmodel.room_num" placeholder="请选择房间"
					v-el-select-loadmore="loadmore" @change="changeselect">
					<el-option v-for=" item in options" :key="item.id" :label="item.flat+`—`+item.room_num"
						:value="item.room_num">
					</el-option>
				</el-select>
			</el-form-item>
			<!-- <el-form-item label="起租日期" prop="start_time"><br>
				<el-date-picker style="width: 100%;" v-model="inputmodel.start_time" type="date" placeholder="选择日期"
					format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
				</el-date-picker>
			</el-form-item> -->
			<el-form-item label="交租类型" prop="type"><br>
				<el-radio v-model="inputmodel.type" label="1">月度交租</el-radio>
				<el-radio v-model="inputmodel.type" label="2">季度交租</el-radio>
			</el-form-item>
			<el-form-item label="状态" prop="status"><br>
				<el-radio v-model="inputmodel.status" label="1">在租</el-radio>
				<el-radio v-model="inputmodel.status" label="0">已退租</el-radio>
			</el-form-item>

		</el-form>
		<div style="width: 100%;">
			<quill-editor class="ql-editor" v-model="inputmodel.content" ref="myQuillEditor" :options="editorOption"
				@blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)">
			</quill-editor>
		</div>
		<el-upload class="avatar-uploader" :http-request="Uploadfwb" action="" name="img" accept=".jpg,.png"
			:show-file-list="false" style="height: 1px">
		</el-upload>
		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>
<script>
	import {
		up_img,
		get_house,
		contract_edit,
		house_list
	} from "@/api/api.js"
	import {
		BASEURL
	} from "@/Utils/request.js";
	import {
		quillEditor
	} from "vue-quill-editor";
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	import Quill from 'quill' // 引入编辑器
	// 自定义字体大小
	const Size = Quill.import('attributors/style/size')
	Size.whitelist = ['10px', '12px', '16px', '18px', '20px', '30px', '32px']
	Quill.register(Size, true)

	// 自定义字体类型
	var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif']
	var Font = Quill.import('formats/font')
	Font.whitelist = fonts
	Quill.register(Font, true)
	export default {
		directives: {
			'el-select-loadmore': {
				bind(el, binding) {
					const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
					SELECTWRAP_DOM.addEventListener('scroll', function() {
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				}
			}
		},
		props: [
			"item"
		],
		data() {
			return {
				name: '',
				dialog_span: [{
						name: '合同编号',
						model: 'number'
					}, {
						name: '姓名',
						model: 'name'
					}, {
						name: '手机号',
						model: 'phone'
					}, {
						name: '身份证号',
						model: 'card_id'
					}, {
						name: '租金',
						model: 'rent'
					},
					// {
					// 	name: '押金',
					// 	model: 'deposit'
					// }, 
					{
						name: '物业费',
						model: 'property_fee'
					}, {
						name: '租期(月)',
						model: 'month'
					}, {
						name: '违约金间隔(天)',
						model: 'dedit_inter'
					}, {
						name: '权限禁用产生间隔(天)',
						model: 'auth_inter'
					},
				],
				inputmodel: {
					number: '',
					name: '',
					phone: '',
					rid: '',
					room_num: '',
					start_time: '',
					card_id: '',
					rent: '',
					deposit: '',
					property_fee: '',
					month: '',
					dedit_inter: '',
					auth_inter: '',
					type: '',
					content: '',
					status: ''
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 0,
					rent_status: 0
				},

				fwq: [], // 用于存储服务器返回的图片URL
				// 富文本编辑器配置
				editorOption: {
					theme: "snow",
					history: {
						delay: 1000,
						maxStack: 50,
						userOnly: false,
					},
					placeholder: "请在这里输入",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								["blockquote", "code-block"], //引用，代码块
								[{
									header: 1
								}, {
									header: 2
								}], // 几级标题
								[{
									list: "ordered"
								}, {
									list: "bullet"
								}], // 有序列表，无序列表
								[{
									script: "sub"
								}, {
									script: "super"
								}], // 下角标，上角标
								[{
									indent: "-1"
								}, {
									indent: "+1"
								}], // 缩进
								[{
									direction: "rtl"
								}], // 文字输入方向
								[{
									'size': ['12', false, '16', '18', '20', '24', '28', '32', '36']
								}], // 字体大小
								[{
									header: [1, 2, 3, 4, 5, 6, false]
								}], // 标题
								[{
									color: []
								}, {
									background: []
								}], // 颜色选择
								[{
									'font': [false, 'heiti', 'songti', 'kaiti', 'lishu', 'arial', 'monospace']
								}], // 字体
								[{
									align: []
								}], // 居中
								["clean"], // 清除样式,
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: (value) => {
									if (value) {
										// 调用element的图片上传组件
										document.querySelector(".avatar-uploader input").click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
						},
					},
				}
			}
		},
		methods: {
			qx(i) {
				console.log(this.inputmodel);

				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							if (this.fwq.length > 0) {
								this.inputmodel.aid = []
								this.fwq.forEach(user => {
									this.inputmodel.aid.push(user.id);
								});
							}
							contract_edit(this.inputmodel).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				// this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				get_house(formData).then(res => {
					const _res = res.data
					this.options = [...this.options, ..._res];
				})

			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
			formatAmount(field) {
				if (this.inputmodel[field] !== undefined && typeof this.inputmodel[field] === 'number') {
					this.inputmodel[field] = parseFloat(this.inputmodel[field].toFixed(2));
				}
			},
			// 多选框
			changeselect(value) {
				// value 是被选中的房间号
				const fieldsToUpdate = ['rent', 'deposit', 'property_fee'];

				// 查找对应的 item
				const selectedItem = this.options.find(item => item.room_num === value);
				if (selectedItem) {
					console.log('Selected item:', selectedItem);
					this.inputmodel.rid = selectedItem.id;

					house_list({
						room_num: value
					}).then(res => {
						// 检查并更新 inputmodel 中的字段
						fieldsToUpdate.forEach(field => {
							const fieldValue = res.data.list[0][field];
							if (typeof fieldValue === 'number') {
								this.inputmodel[field] = parseFloat(fieldValue.toFixed(2));
							} else {
								this.inputmodel[field] = fieldValue; // 如果不是数字类型，则直接赋值
							}
						});
					});
				}
			},
			// 失去焦点事件
			onEditorBlur(quill) {
				console.log('editor blur!', quill)
			},
			// 获得焦点事件
			onEditorFocus(quill) {
				console.log('editor focus!', quill)
			},
			// 准备富文本编辑器
			onEditorReady(quill) {
				console.log('editor ready!', quill)
			},
			// 内容改变事件
			onEditorChange({
				quill,
				html,
				text
			}) {
				console.log('editor change!', quill, html, text)
				this.inputmodel.content = html

			},
			handleRemove(file, fileList) {
				console.log(111111, file, fileList)
			},
			handlePreview(file) {
				// console.log(file)
				console.log('点击', this.ruleForm.file)
			},
			uploadChange(file, fileList) {
				// 验证文件数量，替换后仅保留第一个文件
				if (fileList.length > 1) {
					fileList.splice(0, 1)
					console.log('文件1', fileList)
				}
				this.ruleForm.quantity = fileList.length
				this.ruleForm.size = file.size
				this.ruleForm.file = fileList
				this.wenjian1 = file.raw
			},
			Uploadfwb(file) {
				this.uploadImage(file.file);
			},
			base64toFile(dataurl, filename = 'file') {
				let arr = dataurl.split(',')
				let mime = arr[0].match(/:(.*?);/)[1]
				let suffix = mime.split('/')[1]
				let bstr = atob(arr[1])
				let n = bstr.length
				let u8arr = new Uint8Array(n)
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n)
				}
				let file = new File([u8arr], `${filename}.${suffix}`, {
					type: mime
				})
				return file
			},
			async uploadImage(file) {
				const formData = new FormData();
				formData.append('image', file);
				try {
					const res = await up_img(formData);
					let imgdata = {
						id: res.data.id,
						dir: `${BASEURL}storage/${res.data.dir}`
					}
					this.fwq.push(imgdata);
					this.insertImage(`${BASEURL}storage/${res.data.dir}`);
					console.log('up_img:', res);
				} catch (error) {
					console.error('图片上传失败:', error);
				}
			},
			insertImage(url) {
				const quill = this.$refs.myQuillEditor.quill;
				const range = quill.getSelection();
				if (range) {
					quill.insertEmbed(range.index, 'image', url);
					quill.setSelection(range.index + 1);
				}
			},
			checkForDeletedImages(quill) {
				const currentContent = quill.getContents();
				const currentImages = currentContent.ops.filter(op => op.insert && op.insert.image);

				const currentImageUrls = currentImages.map(imageOp => imageOp.insert.image);

				// 找出被删除的图片
				const deletedImageUrls = this.fwq.map(img => img.dir).filter(url => !currentImageUrls.includes(url));

				// 删除对应的图片ID
				this.fwq = this.fwq.filter(img => !deletedImageUrls.includes(img.dir));
				console.log('this.fwq:', this.fwq);
			},
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			get_house().then(res => {
				const _res = res.data
				this.options = _res;
			})
			this.inputmodel = JSON.parse(JSON.stringify(this.item));
			if (this.item.status == '在租') {
				this.inputmodel.status = '1'
				console.log(this.inputmodel.status);
			} else {
				this.inputmodel.status = '0'
			}
			if (this.item.type == '月度交租') {
				this.inputmodel.type = '1'
			} else {
				this.inputmodel.type = '2'
			}
		},
		components: {
			quillEditor
		},
		mounted() {
			let quill = this.$refs.myQuillEditor.quill;
			// 粘贴事件
			quill.root.addEventListener("paste", (evt) => {
				evt.preventDefault(); // 阻止默认的粘贴行为
				const items = evt.clipboardData.items;
				const files = Array.from(items).filter(item => item.type.startsWith('image')).map(item => item.getAsFile());

				if (files.length > 0) {
					files.forEach(file => {
						this.uploadImage(file);
					});
				} else {
					// 处理非图片内容
					const text = evt.clipboardData.getData('text/plain');
					quill.insertText(quill.getSelection().index, text);
				}
			});

			// 监听内容变化
			quill.on('text-change', (delta, oldDelta, source) => {
				if (source === 'user') {
					this.checkForDeletedImages(quill);
				}
			});
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);

				this.inputmodel = JSON.parse(JSON.stringify(this.item));
				if (this.item.status == '在租') {
					this.inputmodel.status = '1'
					console.log(this.inputmodel.status);
				} else {
					this.inputmodel.status = '0'
				}
				if (this.item.type == '月度交租') {
					this.inputmodel.type = '1'
				} else {
					this.inputmodel.type = '2'
				}

			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>
<style>
	.el-upload-list__item {
		margin-top: 0px !important;
	}

	.ql-editor {
		padding: 0;
	}

	.quill-editor /deep/ .ql-container {
		min-height: 220px;

	}

	.ql-container {
		min-height: 230px;
		padding: 1rem;
	}


	.ql-snow .ql-tooltip [data-mode="link"]::before {
		content: "请输入链接地址:";
		left: 0;
	}

	.ql-snow .ql-tooltip.ql-editing {
		left: 0 !important;
	}

	.ql-snow .ql-tooltip {
		left: 0 !important;
	}

	.ql-snow .ql-editor {
		max-height: 300px;
	}

	.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
		border-right: 0px;
		content: "保存";
		padding-right: 0px;
	}

	.ql-snow .ql-tooltip[data-mode="video"]::before {
		content: "请输入视频地址:";
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item::before {
		content: "14px" !important;
		font-size: 14px;
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
		content: "10px" !important;
		font-size: 10px;
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
		content: "12px" !important;
		font-size: 12px;
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
		content: "16px" !important;
		font-size: 16px;
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
		content: "18px" !important;
		font-size: 18px;
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
		content: "20px" !important;
		font-size: 20px;
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
		content: "30px" !important;
		font-size: 30px;
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
		content: "32px" !important;
		font-size: 32px;
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item::before {
		content: "文本" !important;
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
		content: "标题1" !important;
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
		content: "标题2" !important;
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
		content: "标题3" !important;
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
		content: "标题4" !important;
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
		content: "标题5" !important;
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
		content: "标题6" !important;
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item::before {
		content: "标准字体" !important;
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
		content: "衬线字体" !important;
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
		content: "等宽字体" !important;
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimSun"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimSun"]::before {
		content: "宋体" !important;
		font-family: "SimSun";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimHei"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimHei"]::before {
		content: "黑体" !important;
		font-family: "SimHei";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Microsoft-YaHei"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Microsoft-YaHei"]::before {
		content: "微软雅黑" !important;
		font-family: "Microsoft YaHei";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="KaiTi"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="KaiTi"]::before {
		content: "楷体" !important;
		font-family: "KaiTi";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="FangSong"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="FangSong"]::before {
		content: "仿宋" !important;
		font-family: "FangSong";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before {
		content: "Arial" !important;
		font-family: "Arial";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Times-New-Roman"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Times-New-Roman"]::before {
		content: "Times New Roman" !important;
		font-family: "Times New Roman";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="sans-serif"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="sans-serif"]::before {
		content: "sans-serif" !important;
		font-family: "sans-serif";
	}

	.ql-font-SimSun {
		font-family: "SimSun";
	}

	.ql-font-SimHei {
		font-family: "SimHei";
	}

	.ql-font-Microsoft-YaHei {
		font-family: "Microsoft YaHei";
	}

	.ql-font-KaiTi {
		font-family: "KaiTi";
	}

	.ql-font-FangSong {
		font-family: "FangSong";
	}

	.ql-font-Arial {
		font-family: "Arial";
	}

	.ql-font-Times-New-Roman {
		font-family: "Times New Roman";
	}

	.ql-font-sans-serif {
		font-family: "sans-serif";
	}

	.ql-snow.ql-toolbar .ql-formats .ql-revoke {
		width: 20px;
		height: 20px;
		filter: grayscale(100%);
		opacity: 1;
	}

	.ql-snow.ql-toolbar .ql-formats .ql-revoke:hover {
		width: 20px;
		height: 20px;
		filter: none;
		opacity: 0.9;
	}

	/*加上height和滚动属性就可以，滚动条样式是系统默认样式，可能不同*/
	.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
		border-color: #ccc;
		height: 125px;
		overflow: auto;
	}
</style>